import { Component, OnInit, TemplateRef, ViewChild, Inject, ElementRef } from '@angular/core';
import { IColumn, CellType } from '../common/interfaces/IColumn.interface';
import { DataTableFilter, FilterType, FilterOperator, RowChanges } from '../common/models/DataTableFilter.model';
import { TranslationService } from '../common/services/translation.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AttributesDataTableService } from './attributes-data-table.service';
import { AttributeRow } from './attribute-row.model';
import { IPagedDataTable } from '../common/interfaces/IPagedDataTable.interface';

@Component({
    selector: 'cpq-attributes-data-table-dialog',
    templateUrl: './cpq-attributes-data-table-dialog.component.html',
    styleUrls: ['./cpq-attributes-data-table-dialog.component.scss'],
    providers: [AttributesDataTableService],
    standalone: false
})
export class CpqAttributesDataTableDialogComponent implements OnInit {
  @ViewChild('selectTmpl') selectTmpl: TemplateRef<any>;
  @ViewChild('attributesDataTableDialog', { static: true }) dialog: ElementRef;

  public columns = new Array<IColumn>();
  public totalCount: number;
  public filter: DataTableFilter;
  private selectedAttributes = new Array<AttributeRow>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public service: AttributesDataTableService,
    private translateService: TranslationService,
    public dialogRef: MatDialogRef<CpqAttributesDataTableDialogComponent>
  ) {
    this.service.productId = data.productId;
  }

  onClick(event) {
    if (event.target.name !== 'actionMenuBtn' && event.target.parentElement.name !== 'actionMenuBtn') {

    }
  }

  ngOnInit() {
    this.filter = new DataTableFilter();
    this.filter.placeholder = 'Admin.AttributesDataTable.QuickSearch';

    this.columns = [
      {
        cellType: CellType.checkbox,
        name: this.translateService.translate('Admin.Msg.SelectButton'),
        prop: 'selected',
        visible: true,
        editable: true,
        sortable: false,
        minWidth: 75
      },
      {
        prop: 'name',
        name: this.translateService.translate('Admin.PSW.AttributeName'),
        visible: true,
        sortable: true,
        minWidth: 200
      },
      {
        prop: 'type',
        name: this.translateService.translate('xsltTypee'),
        visible: true,
        sortable: true,
        minWidth: 200
      }
    ];
  }

  public onRowsChanged(pagedData: IPagedDataTable<AttributeRow>) {
    this.totalCount = pagedData.totalNumberOfRecords;
  }

  public onRowChanged(rowChanges: RowChanges) {
    this.selectedAttributes = rowChanges.modifiedRows.filter(attribute => attribute.selected === true);
  }

  public save() {
    this.dialogRef.close(this.selectedAttributes);
  }

  public close() {
    this.dialogRef.close(null);
  }
}
